__turbopack_context__.v({
  "dot": "StatusDot-module__4Yl36a__dot",
  "error": "StatusDot-module__4Yl36a__error",
  "info": "StatusDot-module__4Yl36a__info",
  "label": "StatusDot-module__4Yl36a__label",
  "lg": "StatusDot-module__4Yl36a__lg",
  "md": "StatusDot-module__4Yl36a__md",
  "neutral": "StatusDot-module__4Yl36a__neutral",
  "pulse": "StatusDot-module__4Yl36a__pulse",
  "root": "StatusDot-module__4Yl36a__root",
  "sm": "StatusDot-module__4Yl36a__sm",
  "srOnly": "StatusDot-module__4Yl36a__srOnly",
  "statusdot-pulse": "StatusDot-module__4Yl36a__statusdot-pulse",
  "success": "StatusDot-module__4Yl36a__success",
  "warning": "StatusDot-module__4Yl36a__warning",
});
